/* src/app/components/manage-submission-items/manage-submission-items.component.scss */
a:focus,
a:hover {
  color: #23527c;
}
.td-12 {
  width: 12%;
}
.td-20 {
  width: 20%;
}
.e-grid-no-border {
  border: none;
}
.e-grid .e-pager {
  border: none;
}
.no-columnheader {
  display: none;
}
.submission-items-table {
  border: solid 1px #ccc;
  margin-bottom: 5px;
}
.e-grid .e-gridheader-no-header {
  border: none;
}
.table > thead > tr > th {
  border: none;
  background-color: #e6e6e6;
}
.approve-reject-th {
  background-color: #fff !important;
  width: 10%;
  font-weight: normal !important;
  background-image: none !important;
}
.no-top-padding {
  padding-top: 0px;
}
.modelThHeader {
  background-color: #0071bb !important;
  color: #fff;
  font-family: open_sansregular, sans-serif;
  font-size: 16px;
}
.deviceThHeader {
  background-color: #939598 !important;
  color: #fff;
  font-family: open_sansregular, sans-serif;
  font-size: 16px;
}
.left-border {
  border-left: solid 1px #ccc !important;
}
.right-border {
  border-right: solid 1px #ccc !important;
}
.bottom-border {
  border-bottom: solid 1px #ccc !important;
}
.border-top-sides {
  border-top: solid 1px #ccc;
  border-left: solid 1px #ccc;
}
.border-bottom-sides {
  border-bottom: solid 1px #ccc;
  border-left: solid 1px #ccc;
}
.device-table-tr {
  height: 47px;
}
.e-grid .e-gridcontent tr:first-child td {
}
.e-grid table tr td {
  font-size: 14px;
  line-height: 19px;
  vertical-align: middle;
  white-space: nowrap;
}
.no-border-bottom {
  border-bottom: none;
}
.no-border-top {
  border-top: none;
}
.no-border-right {
  border-right: none !important;
}
.table {
  margin: 0;
}
.extra-bottom-margin {
  margin-bottom: 10px;
}
.top-links-div {
  padding-left: 0px;
}
.approve-all-link {
  margin: 0 0 25px 0;
  font-size: 13px;
  padding: 3px;
}
.approve-all-link a {
  background-color: #fff;
  text-align: left;
}
.approve-all-link a:focus {
  background-color: #29A829;
  color: #fff;
  border: solid 1px #29A829;
}
.approve-all-link-selected {
  background-color: #29A829 !important;
  color: #fff !important;
  border: solid 1px #ccc;
  font-size: 13px !important;
}
.reject-all-link {
  background-color: #fff;
  text-align: left;
  font-size: 13px;
}
.reject-all-link a {
  background-color: #fff;
  text-align: left;
  padding: 6px 12px;
}
.reject-all-link-selected {
  background-color: #ed1c24 !important;
  color: #fff !important;
  border: solid 1px #ccc;
  font-size: 13px !important;
  padding: 3px;
}
.left-padding-14 {
  padding-left: 14px !important;
}
.approve-link {
  text-align: center;
  font-size: 15px;
  border: solid 1px #29A829;
  padding: 5px 0;
  position: relative;
  top: -65px;
}
.approve-link a {
  text-decoration: none !important;
  font-family: open_sansregular;
  color: #29A829;
}
.approve-link-selected {
  background-color: #29A829 !important;
  color: #fff !important;
  border: solid 1px #29A829;
  padding: 5px 0;
  text-align: center;
}
.approve-link-selected a {
  color: #fff;
}
.approve-link-selected a i::before {
  content: "\f14a";
  font-size: 16px;
}
.reject-link {
  text-align: center;
  font-size: 15px;
  border: solid 1px #ed1c24;
  padding: 5px 0;
  position: relative;
  top: -80px;
}
.reject-link a {
  text-decoration: none !important;
  font-family: open_sansregular;
  color: #ed1c24;
}
.reject-link-selected {
  background-color: #ed1c24 !important;
  color: #fff !important;
  border: solid 1px #ed1c24;
  padding: 5px 0;
  text-align: center;
}
.reject-link-selected a {
  color: #fff !important;
}
.reject-link-selected a i::before {
  content: "\f14a";
  font-size: 14px;
}
.e-sig-div span {
  background: #fff;
  padding: 0 10px;
}
.tooltip-span {
  padding: 3px 20px;
}
.tr-gap-between-rows {
  background-color: transparent !important;
}
.e-dialog .e-dlg-content {
  padding: 0;
}
.bg-primary {
  border: none;
}
.background-white {
  background-color: #fff !important;
  background-image: none !important;
}
.dialogButton {
  width: 100px;
  margin: 10px;
}
.large-contents-td {
  max-width: 338px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wide-column-chooser {
  width: 320px !important;
}
textarea {
  resize: none;
}
/*# sourceMappingURL=manage-submission-items.component.css.map */
